import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { ErrorBoundary, clientErrorHandler } from '@sm/webassets';

import { sanitizeString } from '@sm/utils';
import DefaultLoader, { MODULE_SKELETONS } from './UCSModuleLoaders';

const UCS_CONTAINER_ID_PREFIX = 'ucs-content';

// TODO: this component is a duplicate of UCSModule from coreweb and
// will need to be moved somewhere common
class UCSModule extends Component {
  static propTypes = {
    className: PropTypes.string,
    moduleName: PropTypes.string,
    customLoader: PropTypes.node,
  };

  static defaultProps = {
    moduleName: null,
    className: null,
    customLoader: null,
  };

  state = {
    data: {
      moduleHTML: null,
    },
    loading: true,
    error: false,
  };

  componentDidMount() {
    this._isMounted = true;
    this.getModuleHTML();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPreloadedModule() {
    const { moduleName } = this.props;
    const moduleContainer = document.getElementById(`${UCS_CONTAINER_ID_PREFIX}-${moduleName}`);
    if (moduleContainer) {
      moduleContainer.remove();
      return moduleContainer.textContent;
    }
    return null;
  }

  async getModuleHTML() {
    const reFetchFailed = () => {
      this.setState({
        loading: false,
        error: true,
      });
    };

    let moduleHTML = this.getPreloadedModule();
    if (!moduleHTML) {
      try {
        moduleHTML = await this.reFetchModule();
        if (!this._isMounted) {
          return null;
        }
      } catch (error) {
        if (!this._isMounted) {
          return null;
        }
        clientErrorHandler.logError(error, 'ucsFetchFailure');
        return reFetchFailed();
      }
    }

    if (moduleHTML === null) {
      return reFetchFailed();
    }

    return this.setState({
      data: { moduleHTML },
      loading: false,
      error: false,
    });
  }

  async reFetchModule() {
    const { moduleName } = this.props;
    const moduleContent = await fetch(`/content/api/ucs/${moduleName}/html`, {
      credentials: 'include',
    });
    const moduleJson = await moduleContent.json();
    return moduleJson.html;
  }

  renderLoadingState = () => {
    const { customLoader, moduleName } = this.props;
    const ModuleLoader = MODULE_SKELETONS[moduleName];

    if (customLoader) {
      return customLoader;
    }

    if (ModuleLoader) {
      return <ModuleLoader />;
    }

    return <DefaultLoader />;
  };

  render() {
    const { className } = this.props;
    const { data, loading, error } = this.state;
    // fail silently
    const errorComponent = null;

    const classNames = classnames('sm-ucs-module__content-container', className);

    return (
      <Choose>
        <When condition={loading}>{this.renderLoadingState()}</When>
        <When condition={error}>{errorComponent}</When>
        <Otherwise>
          <div
            data-testid="UCSModule"
            className={classNames}
            dangerouslySetInnerHTML={{
              __html: sanitizeString(data.moduleHTML),
            }}
          />
        </Otherwise>
      </Choose>
    );
  }
}

const BoundUCSModule = props => (
  <ErrorBoundary>
    <UCSModule {...props} />
  </ErrorBoundary>
);

export default BoundUCSModule;
